import { isOpxHostInitialized } from 'owa-opx';
import { isMyOutlookMetaOsHost } from './isMyOutlookMetaOsHost';
import type { PersonalOsHost } from './PersonalOsHost';

/**
 * Resolves the surface MyOutlook is rendering inside.
 *
 * Not memoized: OPX sets its host API during boot (`setOpxHostApi` in
 * `opxStart`), so an early call would cache `owa` and every later branch would
 * take the wrong arm. The underlying checks are a boolean read and the hosted
 * route check, so recomputing is cheap.
 */
export function getPersonalOsHost(): PersonalOsHost {
    if (isOpxHostInitialized()) {
        return 'opx';
    }
    if (isMyOutlookMetaOsHost()) {
        return 'metaos';
    }
    return 'owa';
}

/**
 * Whether the current host reaches items through a host contract rather than
 * opening them natively in-app. True for OPX and MetaOS, false for standalone
 * OWA. Use this for the "does a host contract apply at all" question; use
 * {@link getPersonalOsHost} when the branches differ per host.
 */
export function isPersonalOsHostEmbedded(): boolean {
    return getPersonalOsHost() !== 'owa';
}
